import { FLIGHT_LIST_SUCCESS, FlightsActionTypes, FlightListState } from './types';

const flightsListInitialState: FlightListState = {
    data: [],
    total: 0,
};
export function getFlights(state = flightsListInitialState, action: FlightsActionTypes) {
    switch (action.type) {
        case FLIGHT_LIST_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}
